import React, { useState } from 'react'

import { XStack, View, styled } from 'tamagui'

import { useLocation } from 'react-router-dom'

import { useAuthContext } from '@data/useAuthContext'

import { Group } from '../Group'
import { Link } from '../Link'
import { Text } from '../Text'
import { Icon } from '../Icon'

export const DynamicIslandAddExpand = () => {
  const [itemHovered, setItemHovered] = useState<
    'event' | 'presentation' | 'guild' | undefined
  >()

  const location = useLocation()

  const { accessToken } = useAuthContext()

  return (
    <Group
      gap='$2'
      highlightedElementProps={{
        borderRadius: '$6',
        backgroundColor: '$lightBlue1',
      }}
      marginHorizontal={-4}
      onHoverOut={() => setItemHovered(undefined)}
    >
      <Group.Item index={0}>
        <Link
          href={accessToken ? '/events/new' : '/sign-up'}
          hoverStyle={{ textDecorationLine: 'none' }}
          padding='$1'
          paddingRight='$5'
          onHoverIn={() => setItemHovered('event')}
          options={{
            state: {
              backgroundLocation: location,
              authRedirectPath: accessToken ? undefined : '/events/new',
            },
          }}
        >
          <XStack gap='$3' alignItems='center'>
            <StyledIconWrapper
              backgroundColor={
                itemHovered == 'event' ? '$lightBlue2' : '$grey3'
              }
            >
              <StyledIcon name='calendar' />
            </StyledIconWrapper>

            <Text>Event</Text>
          </XStack>
        </Link>
      </Group.Item>

      <Group.Item index={1}>
        <Link
          href={accessToken ? '/presentations/new' : '/sign-up'}
          hoverStyle={{ textDecorationLine: 'none' }}
          padding='$1'
          paddingRight='$5'
          onHoverIn={() => setItemHovered('presentation')}
          options={{
            state: {
              backgroundLocation: location,
              authRedirectPath: accessToken ? undefined : '/presentations/new',
            },
          }}
        >
          <XStack gap='$3' alignItems='center'>
            <StyledIconWrapper
              backgroundColor={
                itemHovered == 'presentation' ? '$lightBlue2' : '$grey3'
              }
            >
              <StyledIcon name='projection-screen' />
            </StyledIconWrapper>

            <Text>Presentation</Text>
          </XStack>
        </Link>
      </Group.Item>

      <Group.Item index={2}>
        <Link
          href={accessToken ? '/guilds/new' : '/sign-up'}
          hoverStyle={{ textDecorationLine: 'none' }}
          padding='$1'
          paddingRight='$5'
          onHoverIn={() => setItemHovered('guild')}
          options={{
            state: {
              backgroundLocation: location,
              authRedirectPath: accessToken ? undefined : '/guilds/new',
            },
          }}
        >
          <XStack gap='$3' alignItems='center'>
            <StyledIconWrapper
              backgroundColor={
                itemHovered == 'guild' ? '$lightBlue2' : '$grey3'
              }
            >
              <StyledIcon name='people-community' />
            </StyledIconWrapper>

            <Text>Guild</Text>
          </XStack>
        </Link>
      </Group.Item>
    </Group>
  )
}

const StyledIconWrapper = styled(View, {
  animation: 'fastSpring',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  backgroundColor: '$grey3',
  width: '$6',
  height: '$6',
})

const StyledIcon = styled(Icon, {
  size: '$5',
  padding: 0,
})
